import React from "react";

/**
 * Care for Flora brand logo. The PNG includes the wordmark + tagline, so use
 * `width` (or `style`) to scale it appropriately for each surface.
 *
 * Props:
 *   - width:   Number | String  width in px (default 220)
 *   - alt:     String  override the alt text
 *   - className, style: forwarded to the <img>
 */
export default function BrandLogo({ width = 220, alt = "Care for Flora", className = "", style }) {
  return (
    <img
      src="/care-for-flora-logo.png"
      alt={alt}
      width={width}
      className={className}
      style={{
        display: "block",
        height: "auto",
        objectFit: "contain",
        filter: "drop-shadow(0 6px 22px rgba(76,175,80,0.45))",
        ...style,
      }}
      data-testid="brand-logo"
    />
  );
}
